<template>
  <nav>
    <router-link to="/">Fight</router-link> |
    <router-link to="/inventory">Inventory</router-link> |
    <router-link to="/smithy">Smithy</router-link>
    <template v-if="upgradeStore.hasPurchased('smithy_workflow')">
      | <router-link to="/workflows">Workflows</router-link>
    </template>
  </nav>
  <router-view />
</template>

<script setup>
import { onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import { useGameStore } from "./stores/gameStore.js";
import { useUpgradeStore } from "./stores/upgradeStore.js";

const upgradeStore = useUpgradeStore();
const game = useGameStore();
const router = useRouter();

function handleKeydown(e) {
  if (e.target.tagName === "INPUT" || e.target.tagName === "SELECT" || e.target.tagName === "TEXTAREA") return;
  
  switch (e.key.toLowerCase()) {
    case "1":
    case "f":
      router.push("/");
      break;
    case "2":
    case "i":
      router.push("/inventory");
      break;
    case "3":
    case "s":
      router.push("/smithy");
      break;
    case "4":
    case "w":
      if (upgradeStore.hasPurchased("smithy_workflow")) {
        router.push("/workflows");
      }
      break;
    case " ":
      e.preventDefault();
      game.togglePause();
      break;
  }
}

onMounted(() => {
  window.addEventListener("keydown", handleKeydown);
});

onUnmounted(() => {
  window.removeEventListener("keydown", handleKeydown);
});
</script>

<style>
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  background: #0d1117;
}

#app {
  font-family: 'Segoe UI', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #e2e8f0;
  min-height: 100vh;
}

nav {
  padding: 20px 30px;
  background: #161b22;
  border-bottom: 1px solid #30363d;
}

nav a {
  font-weight: 600;
  color: #8b949e;
  text-decoration: none;
  padding: 8px 16px;
  border-radius: 6px;
  transition: all 0.2s;
}

nav a:hover {
  color: #e2e8f0;
  background: rgba(255, 255, 255, 0.05);
}

nav a.router-link-exact-active {
  color: #58a6ff;
  background: rgba(88, 166, 255, 0.1);
}
</style>
